import { ConsequenceTemplate } from "@/modules/guidelines/domain/Guideline";
import { dateIsInPaths } from '@/utils'

export function canEditAccountMove(invoice, user, feature_repo){
    if (invoice.prorate) {
        if (feature_repo.got_feature('feature_editar_asiento_pago',user)) {
            return 'No es posible editar el asiento con las prorratas activadas.';
        }
        return 'No es posible editar los asientos con las prorratas activadas.';
    }
    console.log(invoice.state,feature_repo.got_feature('feature_only_edit_move_pending_review',user))
    if(invoice.state!='pending_review' && feature_repo.got_feature('feature_only_edit_move_pending_review',user)){
        return 'Solo se pueden editar los asientos cuando la factura está en estado "Pendiente de revisión".';
    }
    if(invoice.static_invoice && !feature_repo.got_feature('feature_edit_move_efactura',user)){
        return 'No es posible editar los asientos de eFacturas .';
    }

    // Check for retention bases, but ignore those with value 0, null or undefined
    for (let key in invoice.metadata) {
        if (key.startsWith('ret_base_')) {
            const value = invoice.metadata[key];
            if (value !== 0 && value !== null && value !== undefined && value !== '') {
                return "No se puede editar el asiento si se especifican bases de retención."
            }
        }
    }

    return ''
}

export function canEditAccountsOnly(invoice, user, feature_repo){
    if (invoice.prorate) {
        if (feature_repo.got_feature('feature_editar_asiento_pago',user)) {
            return 'No es posible editar el asiento con las prorratas activadas.';
        }
        return 'No es posible editar los asientos con las prorratas activadas.';
    }

    if(invoice.state!='pending_review' && feature_repo.got_feature('feature_only_edit_move_pending_review',user)){
        return 'Solo se pueden editar los asientos cuando la factura está en estado "Pendiente de revisión".';
    }

    // Check for retention bases, but ignore those with value 0, null or undefined
    for (let key in invoice.metadata) {
        if (key.startsWith('ret_base_')) {
            const value = invoice.metadata[key];
            if (value !== 0 && value !== null && value !== undefined && value !== '') {
                return "No se puede editar el asiento si se especifican bases de retención."
            }
        }
    }
    return '';
}


export function isTotalAmountCorrect(balance,tolerancy, user, feature_repo){
    if(feature_repo.got_feature('feature_tolerancy_not_applies_total_amount', user)){
        if(balance!=0)
            return false
    }
    else{
        if(balance<-tolerancy || balance>tolerancy)
            return false
    }
    return true
}

export function showErrorRetentionType(invoice){
    if (invoice.state=='error_missing_fields' && invoice.missing_fields.includes('retention_type_name') && invoice.retention_type_name == 'no_applies' && (Boolean(invoice.retention_percent) || Boolean(invoice.retention_amount))){
        return true
    }
    else{
        return false
    }

}

// ---
// convert Date to 'YYYY-MM-DD'
export function formatDate(date: Date): string {
    
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // add needed 0s before ('1' becomes '01')
    const day = date.getDate().toString().padStart(2, '0') // same for days
    return year + '-' + month + '-' + day 
}

// ---
function inAccountingPeriod(dt, document_paths) {
    try {
        if (dt === null) return false
        let date_hyphen = formatDate(dt)
        return dateIsInPaths(date_hyphen, document_paths)
    } catch (error) {
        console.error("inAccountingPeriod() error: ", error)
    }
    return false 
}

// ---
function getConfiguratedDate(inv_date, sel_date, config): Date {
    switch (config) {
        case 'invoice_date':
            return parseSlashSeparatedDate(inv_date)
            break
        case 'today':
            let dt = new Date()
            dt.setHours(0,0,0,0) // set time to 0
            return dt
            break
        case 'configurated':
            return parseSlashSeparatedDate(sel_date)
            break
        default:
            console.error("config field has an unexpected value ; value:" + config)
            return null
    }
}

// ---
export function diff5Years(date_inv, date_acc, acc_config) {
    let dt_inv = parseSlashSeparatedDate(date_inv)
    let dt_acc = getConfiguratedDate(date_inv, date_acc, acc_config)
    if (dt_inv === null || dt_acc === null) return null
    if (isNaN(dt_inv.getTime()) || isNaN(dt_acc.getTime())) return null
    if ((dt_acc.getTime() - dt_inv.getTime()) > 157766400000) return true
    else return false
}

// ---
export function futureDateErrors(dt_inv, dt_acc, dt_reg) {
    let today = new Date()
    today.setHours(0,0,0,0) // set time to 0

    let future_errors = {invoice : false, operation : false, accounting : false, registro : false}
    if (dt_inv !== null && dt_inv > today) future_errors.invoice = true
    if (dt_acc !== null && dt_acc > today) future_errors.accounting = true
    if (dt_reg !== null && dt_reg > today) future_errors.registro = true
    return future_errors
}

// ---
export function invoiceAndFutureDateErrors(inv_date, op_date, acc_date, acc_config, reg_date, reg_config, feature_repo) {
    let date_errors = {invoice : false, operation : false, accounting : false, registro : false}
    let dt_inv = parseSlashSeparatedDate(inv_date)
    let dt_acc = getConfiguratedDate(inv_date, acc_date, acc_config)
    let dt_reg = getConfiguratedDate(inv_date, reg_date, reg_config)
    let dt_op = parseSlashSeparatedDate(op_date)

    if (dt_inv === null) date_errors.invoice = true
    if (dt_op === null) date_errors.operation = true
    if (dt_acc === null || dt_acc < dt_inv) date_errors.accounting = true
    // removed: ... || dt_reg < dt_acc || ... , checks (dt_reg not null) + (not before dt_inv)
    if (dt_reg === null || dt_reg < dt_inv) date_errors.registro = true

    let future_errors = {invoice : false, operation : false, accounting : false, registro : false}
    if (!feature_repo.got_feature('feature_allow_future_invoice')){
        future_errors = futureDateErrors(dt_inv, dt_acc, dt_reg)
    }
    
    return {date: date_errors, future: future_errors}
}

// ---
export function invoiceDateErrors(inv_date, op_date, acc_date, acc_config, reg_date, reg_config, feature_repo) {
    let dateFuture_errors = invoiceAndFutureDateErrors(inv_date, op_date, acc_date, acc_config, reg_date, reg_config, feature_repo)
    return dateFuture_errors.date
}

// ---
export function inAccountingPeriodErrors(inv_date, acc_date, acc_config, reg_date, reg_config, document_paths) {
    
    let dt_inv = parseSlashSeparatedDate(inv_date)
    let dt_acc = getConfiguratedDate(inv_date, acc_date, acc_config)
    let dt_reg = getConfiguratedDate(inv_date, reg_date, reg_config)

    let inAccounting_errors = {
        invoice : !inAccountingPeriod(dt_inv, document_paths),
        accounting : !inAccountingPeriod(dt_acc, document_paths),
        registro : !inAccountingPeriod(dt_reg, document_paths)
    }

    return inAccounting_errors
}

// ---
function splitAndCheckValidDate(str_date) {
    let regex = /^(0?[1-9]|[1-2][0-9]|3[01])\/(0?[1-9]|1[0-2])\/[0-9]{4}$/;
    if (!regex.test(str_date)) return null
    else {
        let date_fields = str_date.split('/')
        if (date_fields.length != 3) return null
        
        let day = parseInt(date_fields[0])
        let month = parseInt(date_fields[1])
        let year = parseInt(date_fields[2])

        let daysList = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        if (month == 1 || month >= 3) {
            if (day > daysList[month - 1]) return null
        }
        else if (month == 2) { // february
            if ( (!(year % 4) && year % 100) || !(year % 400) ) {
                if (day > 29) return null
            }
            else if (day > 28) return null
        }
        return date_fields
    } 
}



// ****************************************
// check if str_date (or today) is in the [max_date, min_date] of any element in document_paths
export function date_inAccountingPeriod(acc_date_config:string, str_date:string, document_paths) {
    let date
    try {
        // 'invoice_date', "2025/12/31",[ { max_date: "2025-12-31", min_date: "2025-01-01" }, { max_date: today.getFullYear() + "-12-31", min_date: today.getFullYear() + "-01-01" } ]
        if (acc_date_config == 'invoice_date' || acc_date_config == 'configurated') {
            let date_fields = str_date.split('/')
            if (date_fields.length == 3) {
                date = date_fields[2] + '-' + date_fields[1] + '-' + date_fields[0]
            }
        }
        else if (acc_date_config == 'today') {
            const today = new Date();
            date = formatDate(today)
        }
        return dateIsInPaths(date, document_paths)
    } catch (error) {
        console.error("date_inAccountingPeriod error: ", error)
    }
    return false
}

export function accountingBeforeInvoice(str_accounting:string, str_invoice:string) {
    
    function parseDate(str_date) {
        // parses date from format "DD/MM/YYYY"
        let regex = new RegExp('[0-9]+\/[0-9]+\/[0-9]+')
        if (!regex.test(str_date)) return null

        let date_fields = str_date.split('/')
        let year = parseInt(date_fields[2])
        let month = parseInt(date_fields[1]) - 1
        let day = parseInt(date_fields[0])

        let d = new Date(year, month, day)
        return d
    }
    
    let dt_accounting = parseDate(str_accounting)
    let dt_invoice = parseDate(str_invoice)
    return dt_accounting < dt_invoice
}

export function removeDuplicates(screen_data, feature_repo, alert){
    const got_feature = feature_repo.got_feature('feature_limit_files_upload')
    if (screen_data.files.length > 1) {
        let uniqueFiles = screen_data.files.filter((item, index, array) => array.findIndex(t => t.name == item.name && t.size == item.size) == index);
        if (uniqueFiles.length != screen_data.files.length) {
            alert("Los archivos duplicados solo se subirán una vez");
        }
        if (!got_feature && uniqueFiles.length > screen_data.limit_batch) {
            alert("Solo se permiten subir " + screen_data.limit_batch + " ficheros a la vez. Si quieres subir más archivos de una sola vez, utiliza un archivo comprimido zip/rar/7z que contenga múltiples archivos.");
            uniqueFiles = uniqueFiles.slice(0, screen_data.limit_batch);
        }
        screen_data.files.length = 0;
        screen_data.files.push(...uniqueFiles);
    }
}

export function checkActivityStatus(screen_data, default_activity, currentCompany){
    console.log(default_activity)
    if (currentCompany.configuration && currentCompany.companydb_type.params.show && currentCompany.companydb_type.params.show.includes('actividad') && !default_activity) {
        screen_data.empty_actividad = true;
    }else{
        screen_data.empty_actividad = false;
    }
}

export function date_to_string(date){
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    return [(dd>9 ? '' : '0') + dd,
        (mm>9 ? '' : '0') + mm,
        date.getFullYear()
        ].join('/');
}

export function isValidDate(d_str){
    let res = false
    try{
        let d_str_split = d_str.split('/')
        let d = new Date(d_str_split[1]+'/'+d_str_split[0]+'/'+d_str_split[2]);
        if (!isNaN(d.getTime())){
        res = true
        }
        if(d_str_split[2].length<2 || d_str_split[2].length>4 || d_str_split[0].length>2 || d_str_split[1].length>2){
            res = false
        }
    }
    catch(err){
        res = false
    }
    return res
}

export function processDateConfig(config, dateValue) {
    if ( config === 'configurated') {
      if (isValidDate(dateValue)) {
        let d_str_split = dateValue.split('/');
        let d = new Date(`${d_str_split[1]}/${d_str_split[0]}/${d_str_split[2]}`);
        return { date: date_to_string(d), invalid: false };
      } else {
        return { date: "", invalid: true };
      }
    }
    return { date: dateValue, invalid: false };
}

export function processBothDateConfig(
    screen_data,
    feature_repo,
    currentCompany = null
){
    let got_feature = feature_repo.got_feature("feature_fecha_registro") && currentCompany && currentCompany.enable_fecha_sii;
    let resultAccounting = processDateConfig(screen_data.accounting_date_config, screen_data.default_accounting_date)
    if (got_feature) {
        let resultRegistro = processDateConfig(screen_data.registro_date_config, screen_data.default_registro_date)
        screen_data.default_accounting_date = resultAccounting.date, 
        screen_data.invalid_default_accounting_date = resultAccounting.invalid,
        screen_data.default_registro_date = resultRegistro.date, 
        screen_data.invalid_default_registro_date = resultRegistro.invalid
    } else {
        screen_data.default_accounting_date = resultAccounting.date, 
        screen_data.invalid_default_accounting_date = resultAccounting.invalid,
        screen_data.default_registro_date = "", 
        screen_data.invalid_default_registro_date = false
    }
}

export function beforeUploadFiles(screen_data, feature_repo, alert, currentCompany, default_activity){
    removeDuplicates(screen_data, feature_repo, alert)
    checkActivityStatus(screen_data, default_activity, currentCompany)
    processBothDateConfig(screen_data, feature_repo, currentCompany)
}

export function isValidExtension(ext, userData){
    let valid_ext = ['pdf','jpg','jpeg','png','zip','rar','7z','tiff']
    if(userData.available_features['feature_upload_excel']){
      valid_ext = valid_ext.concat(['xls', 'xlsx', 'xlsm', 'ods'])
      valid_ext = valid_ext.concat(['xml','xsig'])
    }
    if(userData.available_features['feature_upload_office']){
      valid_ext = valid_ext.concat(['docx', 'doc', 'odt'])
    }
    return valid_ext.includes(ext.toLowerCase())
}

export function excelFileChosen(files, userData){
    let excel_in_files = false
    for (let i in files) {
      let fname = files[i].name.toLowerCase()
      if (fname.endsWith('.xls') || fname.endsWith('.xlsm') || fname.endsWith('.ods') || fname.endsWith('.xlsx')){
        excel_in_files =true
      }
    }
    return userData.available_features['feature_upload_excel'] && files && files.length && excel_in_files;
}

export function setSnackbar(screen_data, color, text) {
    screen_data.snackbar.text = text
    screen_data.snackbar.color = color
    screen_data.snackbar.isVisible = true
}

export async function afterCheckDatesForUploadingFiles(
    screen_data,
    ccc, 
    userData, 
    uuidv4,
    processFile,
    createDocumentBatch,
){
    if(!screen_data.empty_kind && !screen_data.empty_actividad && !screen_data.invalid_default_accounting_date && !screen_data.invalid_default_registro_date){
        for (let i in screen_data.files) {
            screen_data.uploaded_files[screen_data.files[i].name] = false;
        }
        screen_data.uploading = true
        screen_data.uploading_percent = 0
        const cc = await ccc()
        screen_data.invalid_ext = []
        for (let i = 0; i < screen_data.files.length; i++) {
          const ext = screen_data.files[i].name.split('.').pop()
          if(!isValidExtension(ext, userData)){
            screen_data.invalid_ext.push(screen_data.files[i].name)
          }
        }
        let mult_ex_list = false
        if(excelFileChosen(screen_data.files, userData) && screen_data.files.length>1 && screen_data.excel_kind == 'excel_list'){
          mult_ex_list = true
        }
        if(screen_data.invalid_ext.length==0 && !mult_ex_list){
          try {
            let batch_info = []
            for (let i = 0; i < screen_data.files.length; i++) {
                const extension = screen_data.files[i].name.split('.').pop();
                const uuid = uuidv4();
                const file_name = `private/${cc.identityId}/pdfs/${uuid}.${extension}`
                batch_info.push({name: screen_data.files[i].name, 
                                size: screen_data.files[i].size, 
                                uuid: uuid,
                                extension: extension,
                                s3_key: file_name})
                screen_data.uploaded_files[screen_data.uploading_file] = true;
            }
            await createDocumentBatch(batch_info);

            for (let i = 0; i < batch_info.length; i++) {
                screen_data.uploading_file = screen_data.files[i].name;
                screen_data.uploading_percent = i * 100 / screen_data.files.length;
                const extension = batch_info[i].extension;
                const uuid = batch_info[i].uuid;
                await processFile(screen_data.files[i], uuid, extension, cc.identityId, i+1);
            }
            screen_data.uploading_file = '';
            screen_data.uploaded_files = {};

            setSnackbar(screen_data,'success', 'Fichero(s) procesado(s) correctamente');
            screen_data.files = null;
            screen_data.uploading = false;
            screen_data.uploading_percent = 100;
          } catch (error) {
            console.error(error);
            if(error.name=='RequestTimeTooSkewed'){
                screen_data.confirm_title = 'Los siguientes ficheros no se han subido correctamente. Parece que la configuración de la franja horaria de su ordenador no es la correcta.'
            }else{
                screen_data.confirm_title = 'Los siguientes ficheros no se han subido correctamente'
            }
            screen_data.error_dialog = true;
            screen_data.error_uploading = true;
            screen_data.uploading = false;
          }
        }else{
          if(mult_ex_list){
            screen_data.dialog_err_txt = "Los listados excel deben subirse de uno en uno."
          }
          screen_data.error_dialog_ext = true;
          screen_data.uploading = false
        }
    }
}

export async function lastFunctionUploadingFiles(screen_data, feature_repo, currentCompany, cc, userData, uuidv4, processFile, createDocumentBatch, default_activity){
    screen_data.empty_kind=false
    screen_data.empty_actividad=false
    screen_data.invalid_default_accounting_date=false
    screen_data.invalid_default_registro_date=false
    if(!screen_data.kind)
        screen_data.empty_kind=true
    
    await beforeUploadFiles(screen_data,feature_repo,alert, currentCompany, default_activity)

    await afterCheckDatesForUploadingFiles(screen_data, cc, userData, uuidv4, processFile, createDocumentBatch)
}

// export async function createAndProcessBatch(screen_data, cc, userData, uuidv4, processFile, createDocumentBatch){

// }
// ---
function parseSlashSeparatedDate(slashDate:string) {
    let date_fields = splitAndCheckValidDate(slashDate)
    if (date_fields === null || date_fields.length != 3) return null
    else {
        let hyphenDate = date_fields[2] + '-' + date_fields[1] + '-' + date_fields[0]
        let d = new Date(hyphenDate)
        d.setHours(0,0,0,0)
        return d
    }
}

// accepts date strings in format "DD/MM/YYYY" or Date objects
export function dateIsBefore(date1, date2) {
    let dt1 = date1
    let dt2 = date2
    if (typeof date1 === "string") {
        dt1 = parseSlashSeparatedDate(date1)
    }
    if (typeof date2 === "string") {
        dt2 = parseSlashSeparatedDate(date2)
    }
    if (dt1 === null || dt2 === null) return null
    else {
        dt1.setHours(0,0,0,0)
        dt2.setHours(0,0,0,0)
        return dt1 < dt2
    }
}


export function unmatchingThirdError(errorJson): { error:boolean, text:string } {
    let error = (errorJson && errorJson.length && errorJson.includes('third_cif')) ? true : false
    let text = error ? "El CIF indicado en la factura no coincide con el CIF indicado en el proveedor" : ""
    return { error : error, text : text }
}

import { taxService } from "@/services/TaxService"

/**
 * Get taxes configuration (async - loads from backend on first call)
 * @deprecated Use taxService.getTaxes() directly for better control
 */
export async function getTaxes() {
  return await taxService.getTaxes()
}

/**
 * Get taxes synchronously (returns cached if available, otherwise defaults)
 * Use this only if you're sure taxes are already loaded via getTaxes()
 */
export function getTaxesSync() {
  return taxService.getTaxesSync() || taxService.getDefaults()
}

/**
 * Legacy export for backward compatibility
 * This returns default taxes immediately and will be updated after first backend call
 * @deprecated Import taxService directly and use getTaxes() for async loading
 */
export const taxes = taxService.getDefaults()

export const iva_order_company = [
    "igic_ne_0","igic_ne_0_bi","igic_ns_0","igic_0","igic_0_bi","igic_1","igic_3","igic_3_bi", "igic_5", "igic_7","igic_7_bi","igic_95","igic_15","igic_20",
    "vat_ne_0","vat_ns_0","vat_0","vat_2","vat_4","vat_4_prorrata","vat_5","vat_75","vat_10","vat_10_prorrata","vat_10_5","vat_12","vat_21","vat_21_prorrata","vat_21_bi","vat_21_goods_intra","vat_21_services_intra",
    "vat_0_0","vat_4_5","vat_5_625","vat_26_2",'vat_75_1', 'vat_2_026',"vat_11_4",
    "vat_re_5","vat_re_625","vat_re_2","vat_re_4","vat_re_1_75", "vat_re_1", "vat_re_026",
    "igic_cm_3","igic_cm_5","igic_cm_7","igic_cm_95","igic_cm_15","igic_cm_20",
    "igi_0","igi_ex_0","igi_1","igi_2_5","igi_4_5","igi_9_5","igic2019_3","igic2019_6_5", 'igic2019_13_5'
  ]

export let vats = {
    formTag: {
        inv_number: '',
        supplier: '',
        vat_supplier: '',
        customer: '',
        vat_customer: '',
        invoice_date: '',
        due_date: '',
        retention_type: '',
        retention_amount: '',
        total_amount: '',
        other_amounts: ''
    }
}

Object.keys(taxes).forEach((taxKey) => {
  const taxDef = taxes[taxKey];

  if (!Object.keys(vats).includes(taxDef.type)) {
    vats[taxDef.type] = [];
  }

  taxDef["vat"] = taxKey;
  vats[taxDef.type].push(taxDef);

  if (taxDef.type === "vat" && taxKey.startsWith("vat_re_")) {
    sortRETaxesDesc(vats[taxDef.type]);
  }
});

export function sortRETaxesDesc(taxesArray: any[]) {
  taxesArray.sort((taxA, taxB) => {
    const isA_RE = taxA.vat.startsWith("vat_re_");
    const isB_RE = taxB.vat.startsWith("vat_re_");

    if (isA_RE && isB_RE) return taxB.coef - taxA.coef;
    if (isA_RE) return 1;
    if (isB_RE) return -1;
    return 0;
  });
}

function myParseFloat(e){
    if(e)
        return parseFloat(e.toString().replace(',','.'))
    else
        return e

}

export class Amounts {
    metadata: any;
    is_from_facturae: boolean;

    constructor(metadata, is_from_facturae=false) {
        this.metadata = metadata
        this.is_from_facturae = is_from_facturae
    }

    error_total_amount_retention(fieldKey, feature_repo, there_is_base, tolerancy, isTotalAmountCorrect, suma_ret, balance, user, required){
        let error = false
        if(fieldKey=='total_amount'){
            let allow_no_bases = feature_repo.got_feature('feature_allow_no_bases');
            let allow_no_bases_reviso = feature_repo.got_feature('feature_reviso_allow_no_bases');
            if((!there_is_base && !allow_no_bases && !allow_no_bases_reviso) || !isTotalAmountCorrect(balance,tolerancy,user,feature_repo)){
                error=true
            }
        
        }
        else if(['retention_amount','retention_type'].includes(fieldKey)){
            if(required){
                let ret_calc = Math.abs(suma_ret) * Math.abs(myParseFloat(this.metadata['retention_type'])) / 100.0 * 100;
                let decimals_calc = Math.round((ret_calc-Math.trunc(ret_calc))*100)/100;
                let tolerance = 0;
                if (decimals_calc == 0.5) {
                    tolerance = 0.01; //Con 0.005 decimales, permitimos redondeo hacia arriba y hacia abajo.
                }
                let ret_calc_round = Math.round(ret_calc) / 100;
                let ret_amount_round = Math.round(Math.abs(myParseFloat(this.metadata['retention_amount'])) * 100) / 100;
                if(!this.metadata['retention_type'] ||
                (ret_calc_round > Math.round((ret_amount_round+tolerance)*100)/100) || 
                (ret_calc_round < Math.round((ret_amount_round-tolerance)*100)/100) || 
                (this.metadata['retention_type'] && !this.metadata['retention_amount']) || 
                (!this.metadata['retention_type'] && this.metadata['retention_amount'])){
                    error=true
                }
            }
        }
        return error
    }

    suma_bases_cuotas(fieldKey, feature_repo, tabs, typeCheckRet){
        let suma_bases=0.0;
        let suma_ret=0.0;
        let suma_cuotas=0.0;
        let there_is_base=false;
        if(['total_amount'].includes(fieldKey)) {
            ({ there_is_base, suma_cuotas, suma_bases } = this.suma_bases_cuotas_total_amount(this.metadata, feature_repo, tabs));
        }
        if(['retention_amount', 'retention_type'].includes(fieldKey)) {
          suma_ret = this.suma_bases_cuotas_retention(this.metadata, feature_repo, tabs, typeCheckRet);
        }
        return [suma_bases, suma_cuotas, suma_ret, there_is_base];    

    }

    suma_bases_cuotas_total_amount(metadata, feature_repo, tabs) {
        let there_is_base = false;
        let suma_cuotas = 0.0
        let suma_bases = 0.0
        let check_total_all_decimals = feature_repo.got_feature('feature_a3_descuadre_fix') && !['', undefined].includes(metadata['retention_amount']);
        for (var tab in tabs) {
            for (var e in tabs[tab].vats) {
                ({ there_is_base, suma_cuotas, suma_bases } = this.suma_base_cuota_total_amount(tabs, tab, e, metadata, there_is_base, check_total_all_decimals, suma_cuotas, suma_bases));
            }
        }
        return { there_is_base, suma_cuotas, suma_bases };
    }
    

    private suma_base_cuota_total_amount(tabs: any, tab: string, e: string, metadata: any, there_is_base: boolean, check_total_all_decimals: boolean, suma_cuotas: number, suma_bases: number) {
        let met_field = tabs[tab].vats[e].vat;
        let base_field = 'base_' + met_field;
        if (!['', undefined].includes(metadata[met_field]) && !['', undefined].includes(metadata[base_field]))
            there_is_base = true;
        if (metadata[met_field]) {
            if (check_total_all_decimals) {
                suma_cuotas = suma_cuotas + myParseFloat(metadata['base_' + met_field]) * taxes[met_field]['coef'];
            }
            else {
                suma_cuotas = suma_cuotas + myParseFloat(metadata[met_field]);
            }
        }
        if (!base_field.includes('_re_') && metadata[base_field]) {
            suma_bases = suma_bases + myParseFloat(metadata['base_' + met_field]);
        }
        ({ suma_cuotas, suma_bases } = this.suma_base_total_amount_detail(metadata, met_field, suma_cuotas, base_field, suma_bases));
        return { there_is_base, suma_cuotas, suma_bases };
    }

    private suma_base_total_amount_detail(metadata: any, met_field: any, suma_cuotas: number, base_field: string, suma_bases: number) {
        if (metadata['detail_' + met_field] && metadata['detail_' + met_field].length > 0) {
            for (let i in metadata['detail_' + met_field]) {
                if (metadata['detail_' + met_field][i][met_field])
                    suma_cuotas = suma_cuotas + myParseFloat(metadata['detail_' + met_field][i][met_field]);
                if (!base_field.includes('_re_')) {
                    if (metadata['detail_' + met_field][i][base_field]) {
                        suma_bases = suma_bases + myParseFloat(metadata['detail_' + met_field][i][base_field]);
                    }
                }
            }
        }
        return { suma_cuotas, suma_bases };
    }

    suma_bases_cuotas_retention(metadata, feature_repo, tabs, typeCheckRet) {
        let suma_ret = 0.0
        let type_check_ret = typeCheckRet;
        for (var tab in tabs) {
            for (var e in tabs[tab].vats) {
                suma_ret = this.suma_base_cuota_retention(tabs, tab, e, type_check_ret, metadata, suma_ret);
            }
        }
        return suma_ret;
    }
    
    

    private suma_base_cuota_retention(tabs: any, tab: string, e: string, type_check_ret: any, metadata: any, suma_ret: number) {
        let met_field = tabs[tab].vats[e].vat;
        let base_field = 'base_' + met_field;
        let ret_base_field = 'ret_base_' + met_field;
        let not_ret_check = 'not_ret_' + met_field; //branca mauro aplifisa
        let not_apl_ret = 'not_apl_ret_' + met_field; //branca narcís A3
        if (type_check_ret != 'checkbox' || !(not_ret_check in metadata) || !(metadata[not_ret_check])) { //tipus check amb check no marcat no cal sumar res
            if (type_check_ret == 'base' && (metadata[ret_base_field] || metadata[ret_base_field] === 0)) { //si es tipus base amb ret base alimentada sumem aquesta base
                if (metadata[ret_base_field]) {
                    suma_ret += myParseFloat(metadata[ret_base_field]);
                }
            }
            else {
                if (((met_field == 'vat_12' || met_field == 'vat_10_5') && metadata[met_field]) && !metadata[not_apl_ret]) {
                    suma_ret += myParseFloat(metadata[met_field]);
                }
                if (!base_field.includes('_re_') && metadata[base_field]) {
                    if (!metadata[not_apl_ret]) {
                        suma_ret += myParseFloat(metadata['base_' + met_field]);
                    }
                }

                if (type_check_ret == 'detail' && metadata['detail_' + met_field] && metadata['detail_' + met_field].length > 0) {
                    for (let i in metadata['detail_' + met_field]) {
                        if (!base_field.includes('_re_') && metadata['detail_' + met_field][i][base_field] && !metadata['detail_' + met_field][i]['not_apl_ret_' + met_field]) {
                            suma_ret += myParseFloat(metadata['detail_' + met_field][i][base_field]);
                            if ((met_field == 'vat_12' || met_field == 'vat_10_5') && metadata[met_field]) {
                                suma_ret = suma_ret + myParseFloat(metadata['detail_' + met_field][i][met_field]);
                            }
                        }
                    }
                }
            }
        }
        return suma_ret;
    }
}

export function setType0metadata(tax_type, third_info, metadata, commit, SET_IVA_0_FROM_TO) {
    let from = undefined;
    let to = undefined;
    if (tax_type == 'igi') {
        if (third_info.dry_0_percent && !metadata['base_igi_0']) {
            to = 'igi_0';
            if (metadata['base_igi_ex_0']) {
              from = 'igi_ex_0';
            }
        }
        if (!third_info.dry_0_percent && !metadata['base_igi_ex_0']) {
            to = 'igi_ex_0';
            if (metadata['base_igi_0']) {
              from = 'igi_0';
            }
        }
        
        if (from && to) {
            console.log('calling commit')
            commit(SET_IVA_0_FROM_TO, { from, to });
        }
        return
    }
    if (tax_type != 'iva') {
      if (third_info.no_sujeta && !metadata['base_igic_ns_0']) {
        to = 'igic_ns_0';
        if (metadata['base_igic_0'] && !metadata['base_igic_ne_0']) {
          from = 'igic_0';
        }
        else if (!metadata['base_igic_0'] && metadata['base_igic_ne_0']) {
          from = 'igic_ne_0';
        }
      }
      else if (third_info.dry_0_percent && !metadata['base_igic_ne_0']) {
        to = 'igic_ne_0';
        if (metadata['base_igic_0'] && !metadata['base_igic_ns_0']) {
          from = 'igic_0';
        }
        else if (!metadata['base_igic_0'] && metadata['base_igic_ns_0']) {
          from = 'igic_ns_0';
        }
      }
      else if (!third_info.no_sujeta && !third_info.dry_0_percent && !metadata['base_igic_0']) {
        to = 'igic_0';
        if (metadata['base_igic_ns_0'] && !metadata['base_igic_ne_0']) {
          from = 'igic_ns_0';
        }
        else if (!metadata['base_igic_ns_0'] && metadata['base_igic_ne_0']) {
          from = 'igic_ne_0';
        }
      }
      if (from && to) {
        commit(SET_IVA_0_FROM_TO, { from, to });
      }
    }
    if (tax_type != 'igic') {
      from = undefined;
      to = undefined;
      if (third_info.no_sujeta && !metadata['base_vat_ns_0']) {
        to = 'vat_ns_0';
        if (metadata['base_vat_0'] && !metadata['base_vat_ne_0']) {
          from = 'vat_0';
        }
        else if (!metadata['base_vat_0'] && metadata['base_vat_ne_0']) {
          from = 'vat_ne_0';
        }
      }
      else if (third_info.dry_0_percent && !metadata['base_vat_ne_0']) {
        to = 'vat_ne_0';
        if (metadata['base_vat_0'] && !metadata['base_vat_ns_0']) {
          from = 'vat_0';
        }
        else if (!metadata['base_vat_0'] && metadata['base_vat_ns_0']) {
          from = 'vat_ns_0';
        }
      }
      else if (!third_info.no_sujeta && !third_info.dry_0_percent && !metadata['base_vat_0']) {
        to = 'vat_0';
        if (metadata['base_vat_ns_0'] && !metadata['base_vat_ne_0']) {
          from = 'vat_ns_0';
        }
        else if (!metadata['base_vat_ns_0'] && metadata['base_vat_ne_0']) {
          from = 'vat_ne_0';
        }
      }
      else if (third_info.inversion_sujeto_pasivo_igic && !metadata['base_igic_0'] && tax_type == 'iva_igic') {
        to = 'igic_0';
        if (metadata['base_vat_0']) {
          from = 'vat_0';
        }
      }
      
      if (from && to) {
        commit(SET_IVA_0_FROM_TO, { from, to });
      }
    }
  }